import React from "react";

// Official square HITMAX mark, used across the app.
export const Logo = ({ className = "", size = "h-9" }) => (
  <img
    src={`${process.env.PUBLIC_URL || ""}/hitmax-logo.png`}
    alt="HITMAX"
    width="512"
    height="512"
    data-testid="hitmax-logo"
    className={`w-auto object-contain select-none ${size} ${className}`}
    style={{ filter: "drop-shadow(0 1px 4px rgba(0,0,0,0.5))" }}
    draggable="false"
  />
);
